<template>
  <div class="header">
    <div class="container">
      <div class="row clearfix">
        <div class="navbar col-xs-12">
          <div class="row">
            <router-link tag="div" class="navbar-brand" to="/">{{global.name}}</router-link>
            <div class="navbar-collopse" :class="{'nav-open':is_open===1}">
              <button type="button" class="collopse-btn" @click="is_open = -is_open">
                <i class="fa fa-bars"></i>
              </button>
              <ul class="nav clearfix left" @click="is_open = -is_open">
                <router-link tag="li" to="/evaluate" class="item" active-class="active" v-if="!authorized || (viewType === 1 && user.category === 1)">测评中心</router-link>
                <router-link tag="li" to="/company" class="item" active-class="active" v-if="authorized && ( user.role=== 2 || user.role === 3) && viewType === 1">企业控制台</router-link>
                <router-link tag="li" to="/company/dashboard" class="item" active-class="active" v-if="authorized && (user.category ===2 ||  user.role=== 2 || user.role === 3) && viewType === 2">控制台</router-link>
                <router-link tag="li" to="/company/organizations" class="item" active-class="active" v-if="authorized && user.category ===2 && viewType === 2">组织结构</router-link>
                <router-link tag="li" to="/company/hr" class="item" active-class="active" v-if="authorized && user.category ===2  && viewType === 2">HR管理</router-link>
                <router-link tag="li" to="/company/posts" class="item" active-class="active" v-if="authorized && (user.category ===2 ||  user.role=== 2 || user.role === 3) && viewType === 2">岗位管理</router-link>
                <router-link tag="li" to="/company/invitations" class="item" active-class="active" v-if="authorized && (user.category ===2 ||  user.role=== 2 || user.role === 3) && viewType === 2">测评邀请</router-link>
                <router-link tag="li" to="/company/setting" class="item" active-class="active" v-if="authorized && user.category ===2 && viewType === 2">企业设置</router-link>
                <router-link tag="li" to="/user" class="item" active-class="active" v-if="authorized && user.category === 1">个人中心</router-link>
              </ul>
              <div class="user right n-p-r">
                <div v-if="authorized">
                  <div class="user-info right">
                    <router-link to="/user" v-if="user.category === 1 && viewType === 1">
                      <img :src="user.avatar" alt="" class="avatar">
                      <span class="nickname">{{user.nickname + (user.role === 1?'':'-'+(user.company.short_name || user.company.name))}}</span>
                    </router-link>
                    <router-link to="/company" v-if="user.category === 1 && (user.role === 2 ||user.role === 3)&& viewType === 2">
                      <img :src="user.company.logo" alt="" class="avatar">
                      <span class="nickname">{{user.company.short_name || user.company.name}}</span>
                    </router-link>
                    <router-link to="/company" v-if="user.category === 2">
                      <img :src="user.user_company.logo" alt="" class="avatar">
                      <span class="nickname">{{user.user_company.short_name||user.user_company.name}}</span>
                    </router-link>
                    <div class="user-actions">
                      <div class="action" @click="modal.edit = true" v-if="!(user.category === 1 &&(user.role === 2 ||user.role === 3)&& viewType === 2)">修改密码</div>
                      <div class="action" @click="logout()">注销登录</div>
                    </div>
                  </div>
                </div>
                <div v-if="!authorized">
                  <div class="login-btn right">
                    <router-link to="/auth/login">登录</router-link>
                    <router-link to="/auth/register">注册</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- edit -->
    <div v-if="modal.edit">
      <div class="overlay">
      </div>
      <transition name="fade">
        <div class="modal">
          <div class="modal-header">
            {{modal.title}}
            <span class="close" @click="clearEdit()">X</span>
          </div>
          <div class="modal-body" style="width: 360px;">
            <form action="">
              <div class="input-item show-info">
                <span class="label" style="color:#000;">注册邮箱:</span>
                <span class="email">{{user.email}}</span>
              </div>
              <div class="input-item clearfix">
                <div class="col-xs-12 clearfix">
                  <div class="row clearfix">
                    <div class="col-sm-7 n-p-l">
                      <input type="text" class="input" v-model.trim="verifyCode" placeholder="验证码" @blur="validateCode()">
                    </div>
                    <div class="col-sm-5 n-p-r n-p-l">
                      <button type="button" class="btn btn-md btn-primary col-xs-12" :disabled="reset.disabled" @click="resendEmailCode()">{{reset.text}}</button>
                    </div>
                  </div>
                  <div class="row">
                    <span class="input-tips">{{error.code}}</span>
                  </div>
                </div>
              </div>
              <div class="input-item">
                <input type="password" class="input" name="password" placeholder="登录密码：6-16位，由字母、数字、特殊字符组成" required="required" v-model.trim="password" autocomplete="off" style="font-size:12px;">
              </div>
              <div class="input-item">
                <input type="password" class="input" name="confirm_password" placeholder="确认密码：6-16位，由字母、数字、特殊字符组成" required="required" v-model.trim="confirm_password" autocomplete="off" style="font-size:12px;">
                <span class="input-tips">{{error.password}}</span>
              </div>
              <div class="form-group text-center">
                <div class="btn btn-sm btn-primary m-r-md" @click="registerFunc()">修改密码</div>
                <div class="btn btn-sm btn-default" @click="clearEdit()">放弃修改</div>
              </div>
            </form>
          </div>
        </div>
      </transition>
    </div>
    <!-- /edit end -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: function() {
    return {
      is_open: -1,
      modal: {
        edit: false,
        title: "修改密码"
      },
      validate: [0, 0],
      reset: {
        text: "发送验证码",
        disabled: false,
        timer: null,
        seconds: 60
      },
      error: {
        password: "",
        code: "",
        confirm_password: ""
      },
      password: "",
      confirm_password: "",
      verifyCode: "",
      disabled: true
    };
  },
  computed: {
    ...mapGetters({
      user: "loginUser",
      authorized: "authorized",
      viewType: "viewType"
    })
  },
  watch: {
    password: function(now, pre) {
      let that = this;
      if (now !== pre) {
        that.validate[1] = 0;
      }
      if (!that.global.regex.password.test(that.password)) {
        that.validate[1] = 0;
        that.error.password = "格式错误：6-16位字符、数字、特殊字符至少包含两种";
        return;
      } else {
        that.error.password = "";
      }
      if (that.password === "" || that.confirm_password === "") {
        that.validate[1] = 0;
        that.error.password = "";
        return;
      }
      if (that.password === that.confirm_password) {
        that.validate[1] = 1;
        that.error.password = "";
        that.disabled = that.validate.join("") !== "11";
      } else {
        that.validate[1] = 0;
        that.error.password = "两次输入的密码不一致";
      }
    },
    confirm_password: function(now, pre) {
      let that = this;
      if (now !== pre) {
        that.validate[1] = 0;
      }
      if (that.password === "" || that.confirm_password === "") {
        that.validate[1] = 0;
        that.error.password = "";
        return;
      }
      if (!that.global.regex.password.test(that.confirm_password)) {
        that.validate[1] = 0;
        that.error.password = "格式错误：6-16位字符、数字、特殊字符至少包含两种";
        return;
      } else {
        that.error.password = "";
      }
      if (that.password === that.confirm_password) {
        that.validate[1] = 1;
        that.error.password = "";
        that.disabled = that.validate.join("") !== "11";
      } else {
        that.validate[1] = 0;
        that.error.password = "两次输入的密码不一致";
      }
    }
  },
  methods: {
    logout: function() {
      let that = this;
      if (confirm("您要注销登录吗？")) {
        that.$http.get("/api/v1/auth/logout", {}).then(
          res => {
            that.$store.dispatch("clear");
            that.$store.dispatch("clearCompanyResumes");
            that.$router.replace("/");
          },
          res => {}
        );
      }
    },
    validateCode: function() {
      let that = this;
      if (that.verifyCode == "") {
        that.disabled = true;
        that.validate[0] = 0;
        that.error.code = "请输入验证码";
        return;
      }
      if (that.global.regex.verify_code.test(that.verifyCode)) {
        that.error.code = "";
        that.validate[0] = 1;
        that.disabled = that.validate.join("") !== "11";
      } else {
        that.error.code = "请输入正确的验证码";
        that.validate[0] = 0;
        that.disabled = true;
      }
    },
    resendEmailCode: function() {
      let that = this;
      that.reset.disabled = true; // 禁用按钮
      that.$http
        .get(`/api/v1/users/password/email_code?email=${that.user.email}`)
        .then(res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              // 校验成功
              that.reset.seconds = 60;
              that.reset.text = `${that.reset.seconds}s后，重发`;
              that.reset.timer = setInterval(() => {
                // 倒计时
                if (that.reset.seconds === 0) {
                  that.reset.disabled = false;
                  that.reset.text = `重发验证码`;
                  clearInterval(that.reset.timer);
                  that.reset.timer = null;
                } else {
                  that.reset.seconds--;
                  that.reset.text = `${that.reset.seconds} s后，重发`;
                }
              }, 1000);
            } else {
              that.reset.disabled = false;
              alert(data.msg);
            }
          } else {
            alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
          }
        });
    },
    clearEdit: function() {
      let that = this;
      that.modal.edit = false;
      that.verifyCode = "";
      that.password = "";
      that.confirm_password = "";
    },
    registerFunc: function() {
      let that = this;
      if (that.disabled) {
        alert("请填写完成验证信息后，再进行下一步操作");
        return;
      }
      that.disabled = true;
      let user = {
        password: that.password,
        verifyCode: that.verifyCode
      };
      that.$http.put(`/api/v1/users/set_password`, user).then(
        res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              // 校验成功
              that.disabled = true;
              that.clearEdit();
              alert("修改成功");
            } else {
              that.disabled = false;
              alert(data.msg);
            }
          } else {
            alert("服务器繁忙，请稍后再重试操作(╯﹏╰）!!!");
          }
        },
        res => {
          alert("服务器繁忙，请稍后再重试操作(╯﹏╰）!!!");
        }
      );
    }
  }
};
</script>
<style lang="less">
.version {
  font-size: 12px;
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// navbar.vue?0aeeccc9